import { site, hero } from '../content.js'
import Icon from '../components/Icon.jsx'
import { useSignedIn } from '../components/SignIn.jsx'

export default function Hero() {
  const signedIn = useSignedIn()
  return (
    <section className="hero" id="top">
      <div className="container hero-inner">
        <h1 className="display">
          {hero.title}
          <span className="grad-pp">{hero.titleAccent}</span>
        </h1>
        <div className="hero-rule" />
        <p className="lead">
          {hero.subtitleStart} <strong>{hero.subtitleBold}</strong> {hero.subtitleEnd}
        </p>
        {!signedIn && <a href={site.signupUrl} className="btn btn-grad">{hero.primaryCta} <Icon name="arrow" size={18} /></a>}
        <a href="#why" className="explore">Explore<Icon name="chevron" size={16} /></a>
        <div className="hero-visual">
          <img className="hero-promo" src={`${import.meta.env.BASE_URL}screenshots/hero-promo.webp`} srcSet={`${import.meta.env.BASE_URL}screenshots/hero-promo-800.webp 800w, ${import.meta.env.BASE_URL}screenshots/hero-promo.webp 1600w`} sizes="(max-width: 760px) 100vw, 1120px" width="1600" height="1180" fetchPriority="high" alt="One platform, every touchpoint: venue website, dashboard, mobile application, marketplace and promoter website" />
        </div>
      </div>
    </section>
  )
}
